/**
 * Amount to show next to "Order Price" when API leaves `order_item_final_price` at 0
 * but `total_price` (products + order lines) is populated.
 *
 * Priority (first non-zero finite wins): `order_item_final_price` → `total_price` →
 * `total_final_price` → `order_final_price`. If all zero, returns the first defined finite value.
 */
export function getOrderItemPriceInfoDisplayAmount(
  priceInfo: Record<string, unknown> | null | undefined,
): number {
  if (priceInfo == null || typeof priceInfo !== 'object') {
    return 0;
  }

  const num = (v: unknown): number => {
    const x = Number(v);
    return Number.isFinite(x) ? x : NaN;
  };

  const orderItemFinal = num(priceInfo.order_item_final_price);
  const totalPrice = num(priceInfo.total_price);
  const totalFinal = num(priceInfo.total_final_price);
  const orderFinal = num(priceInfo.order_final_price);

  const nonzero = (n: number) => Number.isFinite(n) && n !== 0;

  if (nonzero(orderItemFinal)) return orderItemFinal;
  if (nonzero(totalPrice)) return totalPrice;
  if (nonzero(totalFinal)) return totalFinal;
  if (nonzero(orderFinal)) return orderFinal;

  if (Number.isFinite(orderItemFinal)) return orderItemFinal;
  if (Number.isFinite(totalPrice)) return totalPrice;
  if (Number.isFinite(totalFinal)) return totalFinal;
  if (Number.isFinite(orderFinal)) return orderFinal;
  return 0;
}
